(function () {
  'use strict';

  var queue = [];
  var flushTimer = null;
  var flushAttempts = 0;
  var lastEventAt = Object.create(null);

  function flushClarityQueue() {
    flushTimer = null;
    flushAttempts += 1;

    if (typeof window.clarity === 'function') {
      while (queue.length) {
        window.clarity.apply(window, queue.shift());
      }
      return;
    }

    if (queue.length && flushAttempts < 80) {
      flushTimer = window.setTimeout(flushClarityQueue, 250);
    }
  }

  function clarityCall() {
    var args = Array.prototype.slice.call(arguments);

    if (typeof window.clarity === 'function') {
      window.clarity.apply(window, args);
      return;
    }

    if (queue.length < 50) queue.push(args);
    if (!flushTimer) flushTimer = window.setTimeout(flushClarityQueue, 250);
  }

  function setTag(key, value) {
    if (value === undefined || value === null || value === '') return;
    clarityCall('set', key, String(value).slice(0, 255));
  }

  function emit(name, tags, dedupeMs) {
    var now = Date.now();
    var windowMs = dedupeMs || 0;

    if (windowMs && lastEventAt[name] && now - lastEventAt[name] < windowMs) return;
    lastEventAt[name] = now;

    if (tags) {
      Object.keys(tags).forEach(function (key) {
        setTag(key, tags[key]);
      });
    }

    clarityCall('event', name);
  }

  function productHandle() {
    var match = window.location.pathname.match(/^\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function currentVariantId(form) {
    var scope = form || document;
    var input = scope.querySelector('input[name="id"], select[name="id"]');
    return input ? input.value : '';
  }

  function optionName(input) {
    var selector = input.closest('.product-form__option-selector');
    if (!selector) return '';
    var label = selector.querySelector('.product-form__option-name');
    return label ? label.textContent.replace(':', '').trim().toLowerCase() : '';
  }

  function isSizeOption(input) {
    return /tamanho|size/.test(optionName(input));
  }

  function initializePage() {
    var handle = productHandle();

    if (handle) {
      emit('av_product_view', {
        av_product: handle,
        av_variant: currentVariantId(document)
      }, 1000);
    }

    if (/^\/cart\/?$/.test(window.location.pathname)) {
      emit('av_cart_view', { av_cart_type: 'page' }, 1000);
    }
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!(input instanceof HTMLInputElement || input instanceof HTMLSelectElement)) return;
    if (!input.closest('product-variants') || !isSizeOption(input)) return;

    emit('av_size_selected', {
      av_product: productHandle(),
      av_size: input.value,
      av_variant: currentVariantId(document)
    }, 250);
  }, true);

  document.addEventListener('click', function (event) {
    var target = event.target.closest('button, a, label');
    if (!target) return;

    var buyButton = target.closest('[data-product-add-to-cart-button], button#AddToCart');
    if (buyButton) {
      var source = buyButton.closest('product-sticky-form') || buyButton.classList.contains('flutuante') ? 'sticky' : 'main';
      var buyTags = {
        av_product: productHandle(),
        av_buy_source: source,
        av_variant: currentVariantId(document.getElementById(buyButton.getAttribute('form')) || buyButton.closest('form'))
      };
      emit('av_buy_click', buyTags, 250);
      emit(source === 'sticky' ? 'av_buy_click_sticky' : 'av_buy_click_main', buyTags, 250);
      return;
    }

    var sizeGuideTrigger = target.closest('[data-size-guide-open], #myBtn, .product-form__option-link');
    if (sizeGuideTrigger) {
      var guideType = sizeGuideTrigger.getAttribute('data-size-guide-open');
      emit(guideType === 'fitter' ? 'av_virtual_fitter_open' : 'av_size_guide_open', {
        av_product: productHandle()
      }, 250);
      return;
    }

    var checkoutButton = target.closest('.cart__checkout-button, [name="checkout"], a[href*="/checkout"], button.checkout-button');
    if (checkoutButton) {
      emit('av_checkout_click', { av_checkout_source: window.location.pathname === '/cart' ? 'cart_page' : 'cart_drawer' }, 500);
    }
  }, true);

  document.addEventListener('submit', function (event) {
    if (!event.target.matches('shipping-estimate form, .shipping-estimate__form')) return;
    emit('av_shipping_calculate', {
      av_product: productHandle(),
      av_shipping_context: event.target.closest('shipping-estimate')?.getAttribute('data-context') || 'unknown'
    }, 500);
  }, true);

  document.addEventListener('variant:added', function (event) {
    var variant = event.detail && event.detail.variant;
    emit('av_add_to_cart_success', {
      av_product: productHandle(),
      av_variant: variant && variant.id
    }, 500);
  });

  document.addEventListener('cart-notification:show', function (event) {
    if (!event.detail || event.detail.status !== 'error') return;
    emit('av_add_to_cart_error', { av_product: productHandle() }, 500);
  });

  document.documentElement.addEventListener('cart:refresh', function (event) {
    if (event.detail && event.detail.openMiniCart) {
      emit('av_cart_view', { av_cart_type: 'drawer' }, 500);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePage, { once: true });
  } else {
    initializePage();
  }
})();
